module.exports = __webpack_public_path__ + "img/friendline01-bottom.96a3e52f.jpg";